##
#
# Color picker
# Usage Ex:
# <wm-color-picker fixed-colors="listOfColors" ng-model="product.color" options="colorPickerPanelOptions" data-inline="true"></wm-color-picker>
#
# Internally uses
# @link https://github.com/ruhley/angular-color-picker
#
##
angular
	.module 'App.Directive'
	.directive 'wmColorPicker', ->
		restrict: 'E'
		require: '?ngModel'
		scope:
			choice: '=ngModel'
			fixedColors: '=?'
			inline: '=?'
			options: '=?'
			open: '@?'
		templateUrl: '@directive/input/color-picker/color-picker.view.html'
		link: (scope, elem, attr) ->
			scope.pickerVisible = false

			if angular.isUndefined(scope.open) || ['left', 'right'].indexOf(scope.open) == -1
				scope.open = 'left'

			if angular.isUndefined scope.fixedColors
				scope.fixedColors = [
					"#019EDF",
					"#344EBC",
					"#1896A1",
					"#3D9815",
					"#b59e00",
					"#C04C14",
					"#8F0000",
					"#A0309C",
					"#212223"
				]

			if angular.isUndefined scope.options
				scope.options = {}

			scope.options = angular.merge(
				{
					allowEmpty: true
					alpha: false
					case: 'lower'
					dynamicHue: false
					format: 'hexstring'
					inline: true
					swatch: false
				},
				scope.options
			)

			scope.isLightColor = (color) ->
				if _.isEmpty(color) or tinycolor(color).isValid()
					return tinycolor(color).isLight()
				return tinycolor(color).isDark()

			scope.eventsApi =
				onChange: (api, color, event) ->
					if not angular.element(event.target).hasClass('color-picker-slider')
						scope.pickItem(color)

			scope.togglePicker = (state = !scope.pickerVisible) ->
				scope.pickerVisible = state if not scope.inline

			scope.pickItem = (item) ->
				if not _.isEmpty(item) and tinycolor(item).isValid()
					scope.choice = tinycolor(item).toHexString()
				else
					scope.choice = null

				scope.pickerVisible = false

			scope.pickItem(scope.choice)

			scope.amendHashTag = ->
				if not _.isEmpty(scope.choice) && scope.choice.charAt(0) != '#'
					scope.choice = '#' + scope.choice
